module.exports = __webpack_public_path__ + "img/zyyhpz.723571cc.svg";